export default "__VITE_ASSET__e47e312c__"